import { Icon, eco_label_v3 } from '../../components/Icon/Icon';
import { Fragment, useState } from 'react';
import './EcoLabel.css';
import { useTranslation } from '../../i18n/i18n';

const EcoLabel = ({ small, name }: { small?: boolean; name: string }) => {
	return <div className={`eco-label eco-${name} ${small ? 'small' : ''}`}></div>;
};

type EcoLabelsProps = {
	ecoLabels: string[];
	isLoggedIn: boolean;
	hasRibbon?: boolean;
	size?: number;
};
export const EcoLabels = ({ ecoLabels, isLoggedIn, hasRibbon, size }: EcoLabelsProps): JSX.Element => {
	const [isTooltipVisible, setIsTooltipVisible] = useState(false);

	const handleMouseEnter = () => {
		setIsTooltipVisible(true);
	};

	const handleMouseLeave = () => {
		setIsTooltipVisible(false);
	};

	if (ecoLabels.length < 1) return <div></div>;

	return (
		<>
			<div
				className={`eco-labels ${isLoggedIn ? 'logged-in' : ''} ${hasRibbon ? 'has-ribbon' : ''}`}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				<Icon shape={eco_label_v3} size={size ?? 32} />
			</div>
			{isTooltipVisible ? (
				<EcoLabelsTooltip ecoLabels={ecoLabels} isLoggedIn={isLoggedIn} hasRibbon={hasRibbon} />
			) : null}
		</>
	);
};

const EcoLabelsTooltip = ({ ecoLabels, isLoggedIn, hasRibbon }: EcoLabelsProps): JSX.Element => {
	const t = useTranslation().ecoLabels;
	const ecoLabelsNames: { [key: string]: string } = {
		svanen: t.svanen,
		bramiljoval: 'Bra Miljöval',
		fairtrade: 'Fairtrade',
		fsc: 'FSC',
		'fsc-100': 'FSC 100%',
		'fsc-mix': 'FSC Mix',
		'fsc-recycled': 'FSC Recycled',
		'austrian-ecolabel': 'Austrian Ecolabel',
		'climate-neutral': 'Climate Neutral',
		'co2-neutrale-productie': 'CO2 Neutrale Productie',
		'nf-environment': 'NF Environment',
		'pefc-certified': 'PEFC Certified',
		'q-conscious': 'Q-Conscious',
		krav: 'Krav',
		ra: 'Rainforest Alliance',
		eotp: 'Easy on the Planet',
		eu: t.eu,
		giftfri: t.giftfri,
		'oeko-tex': 'Standard 100 by OEKO-TEX',
		ecomark: 'Ecomark',
		vegan: 'Vegan',
		cradle2cradle: t.cradle2cradle,
		'blue-angel': 'Blauer Engel',
		grs: 'GRS',
		recycled: 'SCS Recycled Content Certified',
	};
	if (ecoLabels.length < 1) return <></>;
	return (
		<div className={`eco-labels-tooltip ${isLoggedIn ? 'logged-in' : ''} ${hasRibbon ? 'has-ribbon' : ''}`}>
			<div className="eco-label-grid">
				{ecoLabels.map((label) => (
					<Fragment key={label}>
						<EcoLabel name={label} small />
						<span className="eco-label-name">{ecoLabelsNames[label]}</span>
					</Fragment>
				))}
			</div>
		</div>
	);
};
